import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as C}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as l}from"../../icon-registry.js";const p=l("india",C`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="white" />
            <path
                d="M0 4.5H24V9.83333H0V4.5Z"
                fill="#F15B25" />
            <path
                d="M0 15.167H24V20.5003H0V15.167Z"
                fill="#006934" />
            <path
                d="M11.9999 14.9665C13.3622 14.9665 14.4665 13.8622 14.4665 12.4999C14.4665 11.1376 13.3622 10.0332 11.9999 10.0332C10.6376 10.0332 9.5332 11.1376 9.5332 12.4999C9.5332 13.8622 10.6376 14.9665 11.9999 14.9665Z"
                fill="#2C2C6F" />
            <path
                d="M12.0005 14.6329C13.1787 14.6329 14.1339 13.6778 14.1339 12.4995C14.1339 11.3213 13.1787 10.3662 12.0005 10.3662C10.8223 10.3662 9.86719 11.3213 9.86719 12.4995C9.86719 13.6778 10.8223 14.6329 12.0005 14.6329Z"
                fill="white" />
            <path
                d="M11.9989 12.9266C12.2346 12.9266 12.4256 12.7356 12.4256 12.4999C12.4256 12.2643 12.2346 12.0732 11.9989 12.0732C11.7633 12.0732 11.5723 12.2643 11.5723 12.4999C11.5723 12.7356 11.7633 12.9266 11.9989 12.9266Z"
                fill="#2C2C6F" />
            <path
                d="M11.9999 10.3662L12.0799 11.65L11.9999 12.2856L11.9199 11.65L11.9999 10.3662Z"
                fill="#2C2C6F" />
            <path
                d="M12.2674 10.4765C12.3185 10.4833 12.3654 10.4473 12.3721 10.3962C12.3788 10.3451 12.3429 10.2982 12.2918 10.2915C12.2406 10.2848 12.1938 10.3207 12.187 10.3718C12.1803 10.4229 12.2163 10.4698 12.2674 10.4765Z"
                fill="#2C2C6F" />
            <path
                d="M12.0001 14.6318L11.9201 13.3481L12.0001 12.7125L12.0801 13.3481L12.0001 14.6318Z"
                fill="#2C2C6F" />
            <path
                d="M11.7326 14.5215C11.6815 14.5148 11.6346 14.5507 11.6279 14.6019C11.6212 14.653 11.6571 14.6998 11.7082 14.7066C11.7594 14.7133 11.8062 14.6773 11.813 14.6262C11.8197 14.5751 11.7837 14.5282 11.7326 14.5215Z"
                fill="#2C2C6F" />
            <path
                d="M12.5514 10.4397L12.2964 11.7004L12.0546 12.2936L12.1419 11.659L12.5514 10.4397Z"
                fill="#2C2C6F" />
            <path
                d="M12.7799 10.6164C12.8276 10.6361 12.8822 10.6135 12.9019 10.5659C12.9216 10.5182 12.899 10.4636 12.8514 10.4439C12.8037 10.4242 12.7491 10.4468 12.7294 10.4944C12.7097 10.5421 12.7323 10.5967 12.7799 10.6164Z"
                fill="#2C2C6F" />
            <path
                d="M11.4481 14.5603L11.7031 13.2996L11.9449 12.7064L11.8577 13.341L11.4481 14.5603Z"
                fill="#2C2C6F" />
            <path
                d="M11.2196 14.3836C11.172 14.3639 11.1174 14.3865 11.0976 14.4341C11.0779 14.4818 11.1005 14.5364 11.1481 14.5561C11.1958 14.5758 11.2504 14.5532 11.2701 14.5056C11.2898 14.4579 11.2672 14.4033 11.2196 14.3836Z"
                fill="#2C2C6F" />
            <path
                d="M13.0639 10.6523L12.4913 11.8041L12.1042 12.3145L12.3528 11.7241L13.0639 10.6523Z"
                fill="#2C2C6F" />
            <path
                d="M13.2382 10.8817C13.2791 10.913 13.3377 10.9053 13.3691 10.8644C13.4005 10.8235 13.3928 10.765 13.3519 10.7336C13.311 10.7022 13.2524 10.7099 13.221 10.7508C13.1896 10.7917 13.1973 10.8503 13.2382 10.8817Z"
                fill="#2C2C6F" />
            <path
                d="M10.9332 14.3467L11.5058 13.195L11.8928 12.6845L11.6443 13.275L10.9332 14.3467Z"
                fill="#2C2C6F" />
            <path
                d="M10.7588 14.1174C10.7179 14.086 10.6593 14.0937 10.628 14.1346C10.5966 14.1755 10.6043 14.2341 10.6452 14.2654C10.6861 14.2968 10.7447 14.2891 10.7761 14.2482C10.8074 14.2073 10.7997 14.1487 10.7588 14.1174Z"
                fill="#2C2C6F" />
            <path
                d="M13.5102 10.9911L12.659 11.9555L12.153 12.3483L12.5459 11.8423L13.5102 10.9911Z"
                fill="#2C2C6F" />
            <path
                d="M13.6202 11.257C13.6515 11.2979 13.7101 11.3056 13.751 11.2742C13.7919 11.2429 13.7996 11.1843 13.7682 11.1434C13.7369 11.1025 13.6783 11.0948 13.6374 11.1262C13.5965 11.1575 13.5888 11.2161 13.6202 11.257Z"
                fill="#2C2C6F" />
            <path
                d="M10.4864 14.0069L11.3376 13.0426L11.8436 12.6497L11.4507 13.1557L10.4864 14.0069Z"
                fill="#2C2C6F" />
            <path
                d="M10.3764 13.741C10.3451 13.7001 10.2865 13.6924 10.2456 13.7238C10.2047 13.7552 10.197 13.8138 10.2283 13.8547C10.2597 13.8956 10.3183 13.9033 10.3592 13.8719C10.4001 13.8405 10.4078 13.7819 10.3764 13.741Z"
                fill="#2C2C6F" />
            <path
                d="M13.8486 11.4335L12.7768 12.1447L12.1864 12.3932L12.6968 12.0061L13.8486 11.4335Z"
                fill="#2C2C6F" />
            <path
                d="M13.8847 11.7192C13.9045 11.7668 13.9591 11.7894 14.0067 11.7697C14.0543 11.75 14.0769 11.6954 14.0572 11.6478C14.0375 11.6001 13.9829 11.5775 13.9353 11.5972C13.8876 11.617 13.865 11.6716 13.8847 11.7192Z"
                fill="#2C2C6F" />
            <path
                d="M10.1553 13.5674L11.2271 12.8563L11.8175 12.6078L11.3071 12.9948L10.1553 13.5674Z"
                fill="#2C2C6F" />
            <path
                d="M10.1192 13.2818C10.0994 13.2342 10.0448 13.2116 9.99722 13.2313C9.94959 13.251 9.92698 13.3056 9.9467 13.3532C9.96643 13.4008 10.021 13.4235 10.0687 13.4037C10.1163 13.384 10.1389 13.3294 10.1192 13.2818Z"
                fill="#2C2C6F" />
            <path
                d="M14.0598 11.9484L12.8405 12.3579L12.2058 12.4451L12.799 12.2034L14.0598 11.9484Z"
                fill="#2C2C6F" />
            <path
                d="M14.0224 12.2351C14.0292 12.2862 14.076 12.3221 14.1271 12.3154C14.1782 12.3087 14.2142 12.2618 14.2075 12.2107C14.2008 12.1596 14.1539 12.1236 14.1028 12.1303C14.0517 12.1371 14.0157 12.184 14.0224 12.2351Z"
                fill="#2C2C6F" />
            <path
                d="M9.93828 13.0526L11.1576 12.6431L11.7923 12.5558L11.199 12.7976L9.93828 13.0526Z"
                fill="#2C2C6F" />
            <path
                d="M9.97562 12.7659C9.96889 12.7148 9.92201 12.6788 9.8709 12.6856C9.8198 12.6923 9.78382 12.7392 9.79055 12.7903C9.79728 12.8414 9.84416 12.8774 9.89527 12.8706C9.94637 12.8639 9.98235 12.817 9.97562 12.7659Z"
                fill="#2C2C6F" />
            <path
                d="M14.1309 12.4989L12.8471 12.5789L12.2115 12.4989L12.8471 12.4189L14.1309 12.4989Z"
                fill="#2C2C6F" />
            <path
                d="M14.0195 12.7654C14.0128 12.8165 14.0488 12.8634 14.0999 12.8702C14.151 12.8769 14.1979 12.8409 14.2046 12.7898C14.2113 12.7387 14.1754 12.6918 14.1243 12.6851C14.0732 12.6784 14.0263 12.7143 14.0195 12.7654Z"
                fill="#2C2C6F" />
            <path
                d="M9.86328 12.4971L11.147 12.4171L11.7827 12.4971L11.147 12.5771L9.86328 12.4971Z"
                fill="#2C2C6F" />
            <path
                d="M9.9746 12.2307C9.98132 12.1796 9.94535 12.1327 9.89424 12.1259C9.84314 12.1192 9.79625 12.1552 9.78953 12.2063C9.7828 12.2574 9.81877 12.3043 9.86988 12.311C9.92098 12.3177 9.96787 12.2818 9.9746 12.2307Z"
                fill="#2C2C6F" />
            <path
                d="M14.0594 13.0529L12.7987 12.7979L12.2054 12.5561L12.8401 12.6433L14.0594 13.0529Z"
                fill="#2C2C6F" />
            <path
                d="M13.8817 13.2814C13.8619 13.329 13.8846 13.3836 13.9322 13.4033C13.9798 13.4231 14.0344 13.4005 14.0541 13.3528C14.0739 13.3052 14.0512 13.2506 14.0036 13.2309C13.956 13.2112 13.9014 13.2338 13.8817 13.2814Z"
                fill="#2C2C6F" />
            <path
                d="M9.93526 11.9481L11.196 12.2031L11.7892 12.4449L11.1546 12.3577L9.93526 11.9481Z"
                fill="#2C2C6F" />
            <path
                d="M10.113 11.7196C10.1327 11.672 10.1101 11.6174 10.0624 11.5976C10.0148 11.5779 9.96023 11.6005 9.9405 11.6481C9.92078 11.6958 9.94339 11.7504 9.99101 11.7701C10.0386 11.7898 10.0932 11.7672 10.113 11.7196Z"
                fill="#2C2C6F" />
            <path
                d="M13.8467 13.5673L12.695 12.9947L12.1845 12.6076L12.775 12.8562L13.8467 13.5673Z"
                fill="#2C2C6F" />
            <path
                d="M13.6193 13.7426C13.5879 13.7835 13.5956 13.8421 13.6365 13.8735C13.6774 13.9049 13.736 13.8972 13.7674 13.8563C13.7988 13.8154 13.7911 13.7568 13.7502 13.7254C13.7093 13.694 13.6507 13.7017 13.6193 13.7426Z"
                fill="#2C2C6F" />
            <path
                d="M10.1533 11.4336L11.305 12.0062L11.8155 12.3933L11.225 12.1448L10.1533 11.4336Z"
                fill="#2C2C6F" />
            <path
                d="M10.3807 11.2583C10.4121 11.2174 10.4044 11.1589 10.3635 11.1275C10.3226 11.0961 10.264 11.1038 10.2326 11.1447C10.2012 11.1856 10.2089 11.2442 10.2498 11.2756C10.2907 11.3069 10.3493 11.2992 10.3807 11.2583Z"
                fill="#2C2C6F" />
            <path
                d="M13.5059 14.0087L12.5416 13.1575L12.1487 12.6515L12.6547 13.0444L13.5059 14.0087Z"
                fill="#2C2C6F" />
            <path
                d="M13.2381 14.1187C13.1972 14.1501 13.1895 14.2087 13.2209 14.2496C13.2523 14.2904 13.3108 14.2982 13.3517 14.2668C13.3926 14.2354 13.4003 14.1768 13.369 14.1359C13.3376 14.095 13.279 14.0873 13.2381 14.1187Z"
                fill="#2C2C6F" />
            <path
                d="M10.4902 10.9913L11.4545 11.8425L11.8474 12.3485L11.3413 11.9556L10.4902 10.9913Z"
                fill="#2C2C6F" />
            <path
                d="M10.758 10.8813C10.7989 10.8499 10.8066 10.7913 10.7752 10.7504C10.7438 10.7096 10.6853 10.7018 10.6444 10.7332C10.6035 10.7646 10.5958 10.8232 10.6271 10.8641C10.6585 10.905 10.7171 10.9127 10.758 10.8813Z"
                fill="#2C2C6F" />
            <path
                d="M13.0669 14.3466L12.3558 13.2749L12.1073 12.6844L12.4944 13.1949L13.0669 14.3466Z"
                fill="#2C2C6F" />
            <path
                d="M12.7833 14.3838C12.7356 14.4035 12.713 14.4581 12.7327 14.5057C12.7525 14.5533 12.8071 14.576 12.8547 14.5562C12.9023 14.5365 12.9249 14.4819 12.9052 14.4343C12.8855 14.3867 12.8309 14.364 12.7833 14.3838Z"
                fill="#2C2C6F" />
            <path
                d="M10.9379 10.6514L11.6491 11.7232L11.8976 12.3136L11.5105 11.8032L10.9379 10.6514Z"
                fill="#2C2C6F" />
            <path
                d="M11.2216 10.6143C11.2693 10.5946 11.2919 10.54 11.2721 10.4923C11.2524 10.4447 11.1978 10.4221 11.1502 10.4418C11.1026 10.4615 11.08 10.5161 11.0997 10.5638C11.1194 10.6114 11.174 10.634 11.2216 10.6143Z"
                fill="#2C2C6F" />
            <path
                d="M12.5531 14.5607L12.1436 13.3414L12.0563 12.7068L12.2981 13.3L12.5531 14.5607Z"
                fill="#2C2C6F" />
            <path
                d="M12.2693 14.5224C12.2182 14.5292 12.1823 14.576 12.189 14.6271C12.1957 14.6782 12.2426 14.7142 12.2937 14.7075C12.3448 14.7008 12.3808 14.6539 12.374 14.6028C12.3673 14.5517 12.3204 14.5157 12.2693 14.5224Z"
                fill="#2C2C6F" />
            <path
                d="M11.4498 10.4383L11.8594 11.6576L11.9466 12.2923L11.7048 11.699L11.4498 10.4383Z"
                fill="#2C2C6F" />
            <path
                d="M11.7336 10.4766C11.7847 10.4699 11.8207 10.423 11.814 10.3719C11.8072 10.3208 11.7603 10.2848 11.7092 10.2915C11.6581 10.2983 11.6222 10.3451 11.6289 10.3962C11.6356 10.4474 11.6825 10.4833 11.7336 10.4766Z"
                fill="#2C2C6F" />
        </svg>
    `),d=l("india_rounded",C`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66547)">
                <path
                    d="M-6 0.5H30V24.5H-6V0.5Z"
                    fill="white" />
                <path
                    d="M-6 0.5H30V8.5H-6V0.5Z"
                    fill="#F15B25" />
                <path
                    d="M-6 16.5H30V24.5H-6V16.5Z"
                    fill="#006934" />
                <path
                    d="M12.0008 16.1998C14.0442 16.1998 15.7008 14.5433 15.7008 12.4998C15.7008 10.4564 14.0442 8.7998 12.0008 8.7998C9.95733 8.7998 8.30078 10.4564 8.30078 12.4998C8.30078 14.5433 9.95733 16.1998 12.0008 16.1998Z"
                    fill="#2C2C6F" />
                <path
                    d="M12.0008 15.6998C13.7681 15.6998 15.2008 14.2671 15.2008 12.4998C15.2008 10.7325 13.7681 9.2998 12.0008 9.2998C10.2335 9.2998 8.80078 10.7325 8.80078 12.4998C8.80078 14.2671 10.2335 15.6998 12.0008 15.6998Z"
                    fill="white" />
                <path
                    d="M11.9994 13.1404C12.3528 13.1404 12.6394 12.8538 12.6394 12.5004C12.6394 12.1469 12.3528 11.8604 11.9994 11.8604C11.6459 11.8604 11.3594 12.1469 11.3594 12.5004C11.3594 12.8538 11.6459 13.1404 11.9994 13.1404Z"
                    fill="#2C2C6F" />
                <path
                    d="M11.9989 9.2998L12.1189 11.2254L11.9989 12.1789L11.8789 11.2254L11.9989 9.2998Z"
                    fill="#2C2C6F" />
                <path
                    d="M12.3991 9.4658C12.4758 9.47589 12.5461 9.42193 12.5562 9.34527C12.5663 9.26861 12.5123 9.19829 12.4357 9.1882C12.359 9.1781 12.2887 9.23207 12.2786 9.30872C12.2685 9.38538 12.3225 9.45571 12.3991 9.4658Z"
                    fill="#2C2C6F" />
                <path
                    d="M12.0011 15.6992L11.8811 13.7736L12.0011 12.8202L12.1211 13.7736L12.0011 15.6992Z"
                    fill="#2C2C6F" />
                <path
                    d="M11.6009 15.5332C11.5242 15.5231 11.4539 15.5771 11.4438 15.6538C11.4337 15.7304 11.4877 15.8007 11.5643 15.8108C11.641 15.8209 11.7113 15.767 11.7214 15.6903C11.7315 15.6136 11.6775 15.5433 11.6009 15.5332Z"
                    fill="#2C2C6F" />
                <path
                    d="M12.8229 9.40899L12.4405 11.3001L12.0778 12.1899L12.2086 11.238L12.8229 9.40899Z"
                    fill="#2C2C6F" />
                <path
                    d="M13.1667 9.67359C13.2382 9.70318 13.3201 9.66926 13.3496 9.59782C13.3792 9.52639 13.3453 9.44449 13.2739 9.4149C13.2024 9.38531 13.1205 9.41924 13.091 9.49067C13.0614 9.56211 13.0953 9.644 13.1667 9.67359Z"
                    fill="#2C2C6F" />
                <path
                    d="M11.1736 15.591L11.5561 13.6999L11.9188 12.8101L11.7879 13.762L11.1736 15.591Z"
                    fill="#2C2C6F" />
                <path
                    d="M10.8299 15.3264C10.7584 15.2968 10.6765 15.3307 10.6469 15.4022C10.6174 15.4736 10.6513 15.5555 10.7227 15.5851C10.7941 15.6147 10.876 15.5808 10.9056 15.5093C10.9352 15.4379 10.9013 15.356 10.8299 15.3264Z"
                    fill="#2C2C6F" />
                <path
                    d="M13.5966 9.72895L12.7377 11.4566L12.1571 12.2223L12.5299 11.3366L13.5966 9.72895Z"
                    fill="#2C2C6F" />
                <path
                    d="M13.8591 10.073C13.9204 10.1201 14.0083 10.1085 14.0554 10.0471C14.1024 9.98581 14.0909 9.89792 14.0295 9.85085C13.9682 9.80378 13.8803 9.81535 13.8332 9.87669C13.7862 9.93804 13.7977 10.0259 13.8591 10.073Z"
                    fill="#2C2C6F" />
                <path
                    d="M10.4 15.2701L11.2589 13.5424L11.8395 12.7767L11.4667 13.6624L10.4 15.2701Z"
                    fill="#2C2C6F" />
                <path
                    d="M10.1375 14.926C10.0762 14.879 9.98828 14.8905 9.94121 14.9519C9.89414 15.0132 9.90571 15.1011 9.96706 15.1482C10.0284 15.1952 10.1163 15.1837 10.1634 15.1223C10.2104 15.061 10.1989 14.9731 10.1375 14.926Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.2606 10.2362L12.9839 11.6827L12.2248 12.272L12.8142 11.513L14.2606 10.2362Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.4256 10.636C14.4727 10.6974 14.5605 10.7089 14.6219 10.6619C14.6832 10.6148 14.6948 10.5269 14.6477 10.4656C14.6007 10.4042 14.5128 10.3926 14.4514 10.4397C14.3901 10.4868 14.3785 10.5747 14.4256 10.636Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.73155 14.7618L11.0083 13.3153L11.7674 12.726L11.178 13.485L9.73155 14.7618Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.5666 14.362C9.51953 14.3007 9.43165 14.2891 9.3703 14.3362C9.30896 14.3833 9.29739 14.4711 9.34446 14.5325C9.39153 14.5938 9.47942 14.6054 9.54076 14.5583C9.6021 14.5113 9.61367 14.4234 9.5666 14.362Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.7704 10.8998L13.1628 11.9666L12.2771 12.3394L13.0428 11.7587L14.7704 10.8998Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.8257 11.3293C14.8552 11.4007 14.9371 11.4346 15.0086 11.405C15.08 11.3754 15.1139 11.2936 15.0843 11.2221C15.0547 11.1507 14.9729 11.1168 14.9014 11.1463C14.83 11.1759 14.7961 11.2578 14.8257 11.3293Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.23297 14.1012L10.8406 13.0344L11.7263 12.6616L10.9606 13.2423L9.23297 14.1012Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.17777 13.6717C9.14818 13.6003 9.06628 13.5664 8.99485 13.5959C8.92341 13.6255 8.88949 13.7074 8.91908 13.7789C8.94867 13.8503 9.03057 13.8842 9.102 13.8546C9.17343 13.825 9.20736 13.7431 9.17777 13.6717Z"
                    fill="#2C2C6F" />
                <path
                    d="M15.094 11.6726L13.2651 12.2869L12.3131 12.4177L13.203 12.055L15.094 11.6726Z"
                    fill="#2C2C6F" />
                <path
                    d="M15.038 12.1021C15.0481 12.1788 15.1184 12.2327 15.1951 12.2226C15.2718 12.2125 15.3257 12.1422 15.3156 12.0656C15.3055 11.9889 15.2352 11.9349 15.1586 11.945C15.0819 11.9551 15.0279 12.0254 15.038 12.1021Z"
                    fill="#2C2C6F" />
                <path
                    d="M8.91035 13.3284L10.7393 12.7141L11.6913 12.5833L10.8014 12.9459L8.91035 13.3284Z"
                    fill="#2C2C6F" />
                <path
                    d="M8.96636 12.8989C8.95627 12.8222 8.88594 12.7682 8.80929 12.7783C8.73263 12.7884 8.67867 12.8588 8.68876 12.9354C8.69885 13.0121 8.76918 13.066 8.84583 13.0559C8.92249 13.0459 8.97645 12.9755 8.96636 12.8989Z"
                    fill="#2C2C6F" />
                <path
                    d="M15.2026 12.4999L13.277 12.6199L12.3236 12.4999L13.277 12.3799L15.2026 12.4999Z"
                    fill="#2C2C6F" />
                <path
                    d="M15.0357 12.8991C15.0256 12.9758 15.0795 13.0461 15.1562 13.0562C15.2329 13.0663 15.3032 13.0123 15.3133 12.9357C15.3234 12.859 15.2694 12.7887 15.1927 12.7786C15.1161 12.7685 15.0458 12.8225 15.0357 12.8991Z"
                    fill="#2C2C6F" />
                <path
                    d="M8.80029 12.4991L10.7259 12.3791L11.6794 12.4991L10.7259 12.6191L8.80029 12.4991Z"
                    fill="#2C2C6F" />
                <path
                    d="M8.96727 12.0999C8.97736 12.0232 8.92339 11.9529 8.84674 11.9428C8.77008 11.9327 8.69975 11.9867 8.68966 12.0633C8.67957 12.14 8.73353 12.2103 8.81019 12.2204C8.88685 12.2305 8.95717 12.1766 8.96727 12.0999Z"
                    fill="#2C2C6F" />
                <path
                    d="M15.0935 13.3298L13.2024 12.9473L12.3125 12.5846L13.2645 12.7155L15.0935 13.3298Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.8279 13.6726C14.7983 13.744 14.8322 13.8259 14.9036 13.8555C14.9751 13.8851 15.057 13.8512 15.0866 13.7797C15.1162 13.7083 15.0822 13.6264 15.0108 13.5968C14.9394 13.5672 14.8575 13.6011 14.8279 13.6726Z"
                    fill="#2C2C6F" />
                <path
                    d="M8.90948 11.6722L10.8006 12.0547L11.6904 12.4173L10.7384 12.2865L8.90948 11.6722Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.17505 11.3294C9.20464 11.2579 9.17072 11.176 9.09929 11.1465C9.02785 11.1169 8.94596 11.1508 8.91637 11.2222C8.88678 11.2937 8.9207 11.3755 8.99214 11.4051C9.06357 11.4347 9.14547 11.4008 9.17505 11.3294Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.772 14.1L13.0444 13.2411L12.2787 12.6605L13.1644 13.0333L14.772 14.1Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.4309 14.3625C14.3838 14.4238 14.3954 14.5117 14.4568 14.5588C14.5181 14.6059 14.606 14.5943 14.6531 14.5329C14.7001 14.4716 14.6886 14.3837 14.6272 14.3366C14.5659 14.2896 14.478 14.3011 14.4309 14.3625Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.23187 10.899L10.9595 11.7579L11.7252 12.3385L10.8395 11.9657L9.23187 10.899Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.57299 10.6365C9.62006 10.5752 9.60849 10.4873 9.54715 10.4402C9.48581 10.3932 9.39792 10.4047 9.35085 10.4661C9.30378 10.5274 9.31535 10.6153 9.37669 10.6624C9.43804 10.7094 9.52592 10.6979 9.57299 10.6365Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.2628 14.7616L12.8163 13.4848L12.227 12.7258L12.986 13.3151L14.2628 14.7616Z"
                    fill="#2C2C6F" />
                <path
                    d="M13.863 14.9266C13.8017 14.9736 13.7901 15.0615 13.8372 15.1229C13.8842 15.1842 13.9721 15.1958 14.0335 15.1487C14.0948 15.1016 14.1064 15.0137 14.0593 14.9524C14.0122 14.8911 13.9244 14.8795 13.863 14.9266Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.7372 10.2364L11.1837 11.5132L11.773 12.2722L11.014 11.6829L9.7372 10.2364Z"
                    fill="#2C2C6F" />
                <path
                    d="M10.1409 10.0715C10.2022 10.0244 10.2138 9.93653 10.1667 9.87519C10.1197 9.81384 10.0318 9.80227 9.97044 9.84934C9.9091 9.89641 9.89753 9.9843 9.9446 10.0456C9.99167 10.107 10.0796 10.1186 10.1409 10.0715Z"
                    fill="#2C2C6F" />
                <path
                    d="M13.5992 15.2709L12.5325 13.6633L12.1597 12.7776L12.7403 13.5433L13.5992 15.2709Z"
                    fill="#2C2C6F" />
                <path
                    d="M13.1737 15.3271C13.1022 15.3567 13.0683 15.4386 13.0979 15.51C13.1275 15.5815 13.2094 15.6154 13.2808 15.5858C13.3522 15.5562 13.3862 15.4743 13.3566 15.4029C13.327 15.3314 13.2451 15.2975 13.1737 15.3271Z"
                    fill="#2C2C6F" />
                <path
                    d="M10.4047 9.72809L11.4714 11.3357L11.8442 12.2214L11.2636 11.4557L10.4047 9.72809Z"
                    fill="#2C2C6F" />
                <path
                    d="M10.8302 9.67191C10.9017 9.64232 10.9356 9.56042 10.906 9.48899C10.8764 9.41755 10.7945 9.38363 10.7231 9.41322C10.6517 9.44281 10.6177 9.52471 10.6473 9.59614C10.6769 9.66757 10.7588 9.7015 10.8302 9.67191Z"
                    fill="#2C2C6F" />
                <path
                    d="M12.8294 15.5906L12.2151 13.7617L12.0842 12.8097L12.4469 13.6995L12.8294 15.5906Z"
                    fill="#2C2C6F" />
                <path
                    d="M12.4028 15.5336C12.3261 15.5437 12.2722 15.6141 12.2822 15.6907C12.2923 15.7674 12.3627 15.8213 12.4393 15.8112C12.516 15.8012 12.5699 15.7308 12.5599 15.6542C12.5498 15.5775 12.4794 15.5235 12.4028 15.5336Z"
                    fill="#2C2C6F" />
                <path
                    d="M11.1745 9.40742L11.7888 11.2364L11.9197 12.1884L11.557 11.2985L11.1745 9.40742Z"
                    fill="#2C2C6F" />
                <path
                    d="M11.6011 9.46441C11.6778 9.45432 11.7318 9.38399 11.7217 9.30733C11.7116 9.23067 11.6412 9.17671 11.5646 9.1868C11.4879 9.1969 11.434 9.26722 11.4441 9.34388C11.4541 9.42054 11.5245 9.4745 11.6011 9.46441Z"
                    fill="#2C2C6F" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66547">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `),a=l("INR",C`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66547)">
                <path
                    d="M-6 0.5H30V24.5H-6V0.5Z"
                    fill="white" />
                <path
                    d="M-6 0.5H30V8.5H-6V0.5Z"
                    fill="#F15B25" />
                <path
                    d="M-6 16.5H30V24.5H-6V16.5Z"
                    fill="#006934" />
                <path
                    d="M12.0008 16.1998C14.0442 16.1998 15.7008 14.5433 15.7008 12.4998C15.7008 10.4564 14.0442 8.7998 12.0008 8.7998C9.95733 8.7998 8.30078 10.4564 8.30078 12.4998C8.30078 14.5433 9.95733 16.1998 12.0008 16.1998Z"
                    fill="#2C2C6F" />
                <path
                    d="M12.0008 15.6998C13.7681 15.6998 15.2008 14.2671 15.2008 12.4998C15.2008 10.7325 13.7681 9.2998 12.0008 9.2998C10.2335 9.2998 8.80078 10.7325 8.80078 12.4998C8.80078 14.2671 10.2335 15.6998 12.0008 15.6998Z"
                    fill="white" />
                <path
                    d="M11.9994 13.1404C12.3528 13.1404 12.6394 12.8538 12.6394 12.5004C12.6394 12.1469 12.3528 11.8604 11.9994 11.8604C11.6459 11.8604 11.3594 12.1469 11.3594 12.5004C11.3594 12.8538 11.6459 13.1404 11.9994 13.1404Z"
                    fill="#2C2C6F" />
                <path
                    d="M11.9989 9.2998L12.1189 11.2254L11.9989 12.1789L11.8789 11.2254L11.9989 9.2998Z"
                    fill="#2C2C6F" />
                <path
                    d="M12.3991 9.4658C12.4758 9.47589 12.5461 9.42193 12.5562 9.34527C12.5663 9.26861 12.5123 9.19829 12.4357 9.1882C12.359 9.1781 12.2887 9.23207 12.2786 9.30872C12.2685 9.38538 12.3225 9.45571 12.3991 9.4658Z"
                    fill="#2C2C6F" />
                <path
                    d="M12.0011 15.6992L11.8811 13.7736L12.0011 12.8202L12.1211 13.7736L12.0011 15.6992Z"
                    fill="#2C2C6F" />
                <path
                    d="M11.6009 15.5332C11.5242 15.5231 11.4539 15.5771 11.4438 15.6538C11.4337 15.7304 11.4877 15.8007 11.5643 15.8108C11.641 15.8209 11.7113 15.767 11.7214 15.6903C11.7315 15.6136 11.6775 15.5433 11.6009 15.5332Z"
                    fill="#2C2C6F" />
                <path
                    d="M12.8229 9.40899L12.4405 11.3001L12.0778 12.1899L12.2086 11.238L12.8229 9.40899Z"
                    fill="#2C2C6F" />
                <path
                    d="M13.1667 9.67359C13.2382 9.70318 13.3201 9.66926 13.3496 9.59782C13.3792 9.52639 13.3453 9.44449 13.2739 9.4149C13.2024 9.38531 13.1205 9.41924 13.091 9.49067C13.0614 9.56211 13.0953 9.644 13.1667 9.67359Z"
                    fill="#2C2C6F" />
                <path
                    d="M11.1736 15.591L11.5561 13.6999L11.9188 12.8101L11.7879 13.762L11.1736 15.591Z"
                    fill="#2C2C6F" />
                <path
                    d="M10.8299 15.3264C10.7584 15.2968 10.6765 15.3307 10.6469 15.4022C10.6174 15.4736 10.6513 15.5555 10.7227 15.5851C10.7941 15.6147 10.876 15.5808 10.9056 15.5093C10.9352 15.4379 10.9013 15.356 10.8299 15.3264Z"
                    fill="#2C2C6F" />
                <path
                    d="M13.5966 9.72895L12.7377 11.4566L12.1571 12.2223L12.5299 11.3366L13.5966 9.72895Z"
                    fill="#2C2C6F" />
                <path
                    d="M13.8591 10.073C13.9204 10.1201 14.0083 10.1085 14.0554 10.0471C14.1024 9.98581 14.0909 9.89792 14.0295 9.85085C13.9682 9.80378 13.8803 9.81535 13.8332 9.87669C13.7862 9.93804 13.7977 10.0259 13.8591 10.073Z"
                    fill="#2C2C6F" />
                <path
                    d="M10.4 15.2701L11.2589 13.5424L11.8395 12.7767L11.4667 13.6624L10.4 15.2701Z"
                    fill="#2C2C6F" />
                <path
                    d="M10.1375 14.926C10.0762 14.879 9.98828 14.8905 9.94121 14.9519C9.89414 15.0132 9.90571 15.1011 9.96706 15.1482C10.0284 15.1952 10.1163 15.1837 10.1634 15.1223C10.2104 15.061 10.1989 14.9731 10.1375 14.926Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.2606 10.2362L12.9839 11.6827L12.2248 12.272L12.8142 11.513L14.2606 10.2362Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.4256 10.636C14.4727 10.6974 14.5605 10.7089 14.6219 10.6619C14.6832 10.6148 14.6948 10.5269 14.6477 10.4656C14.6007 10.4042 14.5128 10.3926 14.4514 10.4397C14.3901 10.4868 14.3785 10.5747 14.4256 10.636Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.73155 14.7618L11.0083 13.3153L11.7674 12.726L11.178 13.485L9.73155 14.7618Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.5666 14.362C9.51953 14.3007 9.43165 14.2891 9.3703 14.3362C9.30896 14.3833 9.29739 14.4711 9.34446 14.5325C9.39153 14.5938 9.47942 14.6054 9.54076 14.5583C9.6021 14.5113 9.61367 14.4234 9.5666 14.362Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.7704 10.8998L13.1628 11.9666L12.2771 12.3394L13.0428 11.7587L14.7704 10.8998Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.8257 11.3293C14.8552 11.4007 14.9371 11.4346 15.0086 11.405C15.08 11.3754 15.1139 11.2936 15.0843 11.2221C15.0547 11.1507 14.9729 11.1168 14.9014 11.1463C14.83 11.1759 14.7961 11.2578 14.8257 11.3293Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.23297 14.1012L10.8406 13.0344L11.7263 12.6616L10.9606 13.2423L9.23297 14.1012Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.17777 13.6717C9.14818 13.6003 9.06628 13.5664 8.99485 13.5959C8.92341 13.6255 8.88949 13.7074 8.91908 13.7789C8.94867 13.8503 9.03057 13.8842 9.102 13.8546C9.17343 13.825 9.20736 13.7431 9.17777 13.6717Z"
                    fill="#2C2C6F" />
                <path
                    d="M15.094 11.6726L13.2651 12.2869L12.3131 12.4177L13.203 12.055L15.094 11.6726Z"
                    fill="#2C2C6F" />
                <path
                    d="M15.038 12.1021C15.0481 12.1788 15.1184 12.2327 15.1951 12.2226C15.2718 12.2125 15.3257 12.1422 15.3156 12.0656C15.3055 11.9889 15.2352 11.9349 15.1586 11.945C15.0819 11.9551 15.0279 12.0254 15.038 12.1021Z"
                    fill="#2C2C6F" />
                <path
                    d="M8.91035 13.3284L10.7393 12.7141L11.6913 12.5833L10.8014 12.9459L8.91035 13.3284Z"
                    fill="#2C2C6F" />
                <path
                    d="M8.96636 12.8989C8.95627 12.8222 8.88594 12.7682 8.80929 12.7783C8.73263 12.7884 8.67867 12.8588 8.68876 12.9354C8.69885 13.0121 8.76918 13.066 8.84583 13.0559C8.92249 13.0459 8.97645 12.9755 8.96636 12.8989Z"
                    fill="#2C2C6F" />
                <path
                    d="M15.2026 12.4999L13.277 12.6199L12.3236 12.4999L13.277 12.3799L15.2026 12.4999Z"
                    fill="#2C2C6F" />
                <path
                    d="M15.0357 12.8991C15.0256 12.9758 15.0795 13.0461 15.1562 13.0562C15.2329 13.0663 15.3032 13.0123 15.3133 12.9357C15.3234 12.859 15.2694 12.7887 15.1927 12.7786C15.1161 12.7685 15.0458 12.8225 15.0357 12.8991Z"
                    fill="#2C2C6F" />
                <path
                    d="M8.80029 12.4991L10.7259 12.3791L11.6794 12.4991L10.7259 12.6191L8.80029 12.4991Z"
                    fill="#2C2C6F" />
                <path
                    d="M8.96727 12.0999C8.97736 12.0232 8.92339 11.9529 8.84674 11.9428C8.77008 11.9327 8.69975 11.9867 8.68966 12.0633C8.67957 12.14 8.73353 12.2103 8.81019 12.2204C8.88685 12.2305 8.95717 12.1766 8.96727 12.0999Z"
                    fill="#2C2C6F" />
                <path
                    d="M15.0935 13.3298L13.2024 12.9473L12.3125 12.5846L13.2645 12.7155L15.0935 13.3298Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.8279 13.6726C14.7983 13.744 14.8322 13.8259 14.9036 13.8555C14.9751 13.8851 15.057 13.8512 15.0866 13.7797C15.1162 13.7083 15.0822 13.6264 15.0108 13.5968C14.9394 13.5672 14.8575 13.6011 14.8279 13.6726Z"
                    fill="#2C2C6F" />
                <path
                    d="M8.90948 11.6722L10.8006 12.0547L11.6904 12.4173L10.7384 12.2865L8.90948 11.6722Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.17505 11.3294C9.20464 11.2579 9.17072 11.176 9.09929 11.1465C9.02785 11.1169 8.94596 11.1508 8.91637 11.2222C8.88678 11.2937 8.9207 11.3755 8.99214 11.4051C9.06357 11.4347 9.14547 11.4008 9.17505 11.3294Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.772 14.1L13.0444 13.2411L12.2787 12.6605L13.1644 13.0333L14.772 14.1Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.4309 14.3625C14.3838 14.4238 14.3954 14.5117 14.4568 14.5588C14.5181 14.6059 14.606 14.5943 14.6531 14.5329C14.7001 14.4716 14.6886 14.3837 14.6272 14.3366C14.5659 14.2896 14.478 14.3011 14.4309 14.3625Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.23187 10.899L10.9595 11.7579L11.7252 12.3385L10.8395 11.9657L9.23187 10.899Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.57299 10.6365C9.62006 10.5752 9.60849 10.4873 9.54715 10.4402C9.48581 10.3932 9.39792 10.4047 9.35085 10.4661C9.30378 10.5274 9.31535 10.6153 9.37669 10.6624C9.43804 10.7094 9.52592 10.6979 9.57299 10.6365Z"
                    fill="#2C2C6F" />
                <path
                    d="M14.2628 14.7616L12.8163 13.4848L12.227 12.7258L12.986 13.3151L14.2628 14.7616Z"
                    fill="#2C2C6F" />
                <path
                    d="M13.863 14.9266C13.8017 14.9736 13.7901 15.0615 13.8372 15.1229C13.8842 15.1842 13.9721 15.1958 14.0335 15.1487C14.0948 15.1016 14.1064 15.0137 14.0593 14.9524C14.0122 14.8911 13.9244 14.8795 13.863 14.9266Z"
                    fill="#2C2C6F" />
                <path
                    d="M9.7372 10.2364L11.1837 11.5132L11.773 12.2722L11.014 11.6829L9.7372 10.2364Z"
                    fill="#2C2C6F" />
                <path
                    d="M10.1409 10.0715C10.2022 10.0244 10.2138 9.93653 10.1667 9.87519C10.1197 9.81384 10.0318 9.80227 9.97044 9.84934C9.9091 9.89641 9.89753 9.9843 9.9446 10.0456C9.99167 10.107 10.0796 10.1186 10.1409 10.0715Z"
                    fill="#2C2C6F" />
                <path
                    d="M13.5992 15.2709L12.5325 13.6633L12.1597 12.7776L12.7403 13.5433L13.5992 15.2709Z"
                    fill="#2C2C6F" />
                <path
                    d="M13.1737 15.3271C13.1022 15.3567 13.0683 15.4386 13.0979 15.51C13.1275 15.5815 13.2094 15.6154 13.2808 15.5858C13.3522 15.5562 13.3862 15.4743 13.3566 15.4029C13.327 15.3314 13.2451 15.2975 13.1737 15.3271Z"
                    fill="#2C2C6F" />
                <path
                    d="M10.4047 9.72809L11.4714 11.3357L11.8442 12.2214L11.2636 11.4557L10.4047 9.72809Z"
                    fill="#2C2C6F" />
                <path
                    d="M10.8302 9.67191C10.9017 9.64232 10.9356 9.56042 10.906 9.48899C10.8764 9.41755 10.7945 9.38363 10.7231 9.41322C10.6517 9.44281 10.6177 9.52471 10.6473 9.59614C10.6769 9.66757 10.7588 9.7015 10.8302 9.67191Z"
                    fill="#2C2C6F" />
                <path
                    d="M12.8294 15.5906L12.2151 13.7617L12.0842 12.8097L12.4469 13.6995L12.8294 15.5906Z"
                    fill="#2C2C6F" />
                <path
                    d="M12.4028 15.5336C12.3261 15.5437 12.2722 15.6141 12.2822 15.6907C12.2923 15.7674 12.3627 15.8213 12.4393 15.8112C12.516 15.8012 12.5699 15.7308 12.5599 15.6542C12.5498 15.5775 12.4794 15.5235 12.4028 15.5336Z"
                    fill="#2C2C6F" />
                <path
                    d="M11.1745 9.40742L11.7888 11.2364L11.9197 12.1884L11.557 11.2985L11.1745 9.40742Z"
                    fill="#2C2C6F" />
                <path
                    d="M11.6011 9.46441C11.6778 9.45432 11.7318 9.38399 11.7217 9.30733C11.7116 9.23067 11.6412 9.17671 11.5646 9.1868C11.4879 9.1969 11.434 9.26722 11.4441 9.34388C11.4541 9.42054 11.5245 9.4745 11.6011 9.46441Z"
                    fill="#2C2C6F" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66547">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{a as INR,p as India,d as IndiaRounded};
